import React from "react";

export const FilterChip = ({ label, onClose }: { label: string; onClose?: (label: string) => void }) => {
  return (
    <div className="flex items-center justify-between gap-1 pl-4 pr-2 rounded-full h-[32px] bg-neutrals-lightGrey hover:bg-neutrals-midGrey transition-colors">
      <div className="text-xs text-neutrals-black">{label}</div>
      <button dangerouslySetInnerHTML={{ __html: window.iconCloseXs }} onClick={() => onClose?.(label)} />
    </div>
  );
};
